<template>
  <b-modal
    id="end-trip-modal"
    no-close-on-backdrop
    title="End Trip"
    hide-footer
  >
    <b-tabs>
      <b-tab>
        <template #title>
          <feather-icon
            icon="TruckIcon"
            size="16"
            class="mr-0 mr-sm-50"
          />
          <span class="d-none d-sm-inline">Dropoff</span>
        </template>
        <Map />
      </b-tab>
      <b-tab>
        <template #title>
          <feather-icon
            icon="CalendarIcon"
            size="16"
            class="mr-0 mr-sm-50"
          />
          <span class="d-none d-sm-inline">Distance/Time</span>
        </template>
        <distance-time-tab-vue />
      </b-tab>
    </b-tabs>
  </b-modal>
</template>
<script>
import { BModal, BTabs, BTab } from 'bootstrap-vue'
import Map from './Map.vue'
import DistanceTimeTabVue from './DistanceTimeTab.vue'

export default {
  components: {
    BModal,
    Map,
    DistanceTimeTabVue,
    BTabs,
    BTab,
  },

}
</script>
<style scoped>
</style>
